import { object } from "prop-types";
import React from "react";

import { getStoryDate } from "../../../../utils";

import "./story-date.m.css";

const StoryDate = ({ story }) => {
  return (
    <div styleName="wrapper">
      <div styleName="time published-time">
        <span styleName="title">Published : </span>
        {getStoryDate(story["first-published-at"])}{" "}
      </div>
      <div styleName="time">
        <span styleName="title">Updated : </span>
        {getStoryDate(story["last-published-at"])}{" "}
      </div>
    </div>
  );
};

StoryDate.propTypes = {
  story: object,
};

export default StoryDate;
